module.exports = __webpack_public_path__ + "img/MES-LOGO.01382e26.png";